<template>
  <basepanel>
    <div class="outer-box">
      <!-- horizontal-box 手机端加上该样式 -->
      <div :class="{ 'inner-box': true, 'horizontal-box': phoneshow }">
        <el-tabs v-model="activeIndex" @tab-click="handleClick" class="horizontal-tabs"></el-tabs>

        <div class="all-modules">
          <div class="recruitment">
            <div
              class="job"
              v-for="(val, index) in content"
              :key="index"
              @click="goDetail(val.$document.id)"
            >
              <p class="jobname">
                {{val.position}}
                <span v-if="val.number">({{val.number}})</span>
              </p>
              <p class="mon">
                <span v-if="val.salary">{{val.salary}}</span>
                <el-divider direction="vertical" v-if="val.salary"></el-divider>
                <span v-if="val.experience">{{val.experience}}</span>
                <el-divider direction="vertical" v-if="val.experience"></el-divider>
                <span v-if="val.education">{{val.education}}</span>
              </p>
              <div class="word">
                <p v-for="exp in val.info" :key="exp.id" v-show="val.info">{{exp}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </basepanel>
</template>
<script>
import local from "../../utils/local";
import basepanel from "../../components/BasePanel";
import { listNextWithFilter, view } from "../../api/index";
export default {
  name: "ReDetail",
  components: { basepanel },

  data() {
    return {
      activeIndex: "2", //1核心技术，2人才招聘，3联系我们
      // 核心技术
      coreLists: [],
      // 加入我们
      selectIndex: 0, //默认选中的索引
      jobList: [],
      jobList1: [],
      content: [],
      selectOne: {},
      markerPoint: { lng: 106.51584, lat: 29.620552 },
      screenWidth: document.body.clientWidth
    };
  },
  computed: {
    phoneshow: function() {
      return this.screenWidth < 768 ? true : false;
    }
  },
  methods: {
    handleClick(tab) {
      this.activeIndex = (parseInt(tab.index) + 1).toString();
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      this.activeIndex = key;
    },

    //获取到一级内容标题
    async getJobs() {
      let send = {
        url: {
          page: 1,
          size: 20
        },
        data: {
          categoryIdList: [this.$map.recruitcategoryId]
        }
      };
      let res = await listNextWithFilter(send);
      if (res.type == "success") {
        this.$forceUpdate();
        this.jobList = res.data;
        // this.$forceUpdate();
        for (let i = 0; i < this.jobList.length; i++) {
          this.getJobsDetail(this.jobList[i].id).then(res => {
            this.jobList1[i] = res;
          });
        }
      } else {
        console.log(res.msg);
      }
    },
    // 获取职位详情  待遇  联系方式
    async getJobsDetail(id) {
      let send = {
        url: {
          id
        }
      };
      let res = await view(send);
      if (res.type == "success") {
        let data = res.data.data;
        this.content.push(data);
        data.publishTime = data.$document.publishTime.substring(0, 10); //获取时间
        data.welfare = data.welfare.toString().split("，"); //福利待遇
        data.info = data.information.toString().split("\n"); //岗位职责 任职资格
        for (let i = 0; i < data.info.length; i++) {
          if (data.info[i] == "任职资格：") {
            data.information1 = data.info.splice(0, i); //任职资格
          }
        }

        data.information2 = data.info; //岗位职责
        return data;
      } else {
        console.log(res.msg);
      }
    },
    goDetail(id) {
      this.$router.push("/Detail/recruitment/" + id);
      local.set("prePath", "recruitment");
    }
  },
  watch: {
    screenWidth(newValue) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = newValue;
        this.timer = true;
        setTimeout(() => {
          this.timer = false;
        }, 400);
      }
    }
  },
  mounted() {
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
    };
    this.getJobs();
  }
};
</script>

<style scoped lang="less">
.job {
  // width: 25%;
  padding: 2.25rem 1.25rem;
  margin-bottom: 20px;
  background-color: #eee;
  border-radius: 10px;
  .job:nth-child(3n) {
    margin-right: 0;
  }
  &:hover {
    background-color: rgba(8, 117, 203, 0.07);
  }
  .mon {
    font-size: 20px;
    margin-top: 12px;
    margin-bottom: 20px;
  }
  p {
    // margin: 10px 10px;
    line-height: 25px;
  }
  .el-divider {
    background-color: #444444;
  }
  .active {
    background-color: rgba(8, 117, 203, 0.07);
  }
  .jobname {
    font-weight: bold;
    font-size: 22px;
    color: #333;
  }
  .word {
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    line-clamp: 4;
    -webkit-box-orient: vertical;
    p:nth-of-type(n+4){
      display:none;
    }
  }
}

.aboutus {
  .inner-box {
    display: flex;
    justify-content: space-between;
    .horizontal-tabs {
      display: none;
    }
    .all-modules {
      width: 100%;
      padding-left: 6%;
      .core {
        .sec {
          display: inline-block;
          vertical-align: top;
          // cursor: pointer;
          margin-right: 2%;
          text-decoration: none;
          color: #000;
          // margin-bottom: 20px;
          // background-color: #fff;
          // &:hover {
          //   box-shadow: 0 0 16px #0e6cb6;
          //   transition: all 0.3s ease;
          // }
          .top {
            width: 100%;
          }
          .title {
            // overflow: hidden;
            // text-overflow: ellipsis;
            // white-space: nowrap;
            text-align: center;
          }
        }
        .special {
          margin-right: 0;
        }
        .hint {
          text-align: right;
          margin-top: 6px;
          letter-spacing: 1px;
          // @font-face {
          //   font-family: "iconfont"; /* Project id  */
          //   src: url("../../assets/iconfont.ttf?t=1620782934324")
          //     format("truetype");
          // }

          .iconfont {
            font-family: "iconfont" !important;
            font-size: 16px;
            font-style: normal;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
          }

          .icon-weibiaoti-:before {
            content: "\e613";
          }
        }
      }
      .recruitment {
        ul {
          display: flex;
          flex-wrap: wrap;
          width: 100%;
          li {
            text-align: center;
            // border: 1px solid #010439;
            cursor: pointer;
            // padding: 16px;
            background-color: #e3eaf0;
            border-radius: 6px;
            color: #333333;
            // margin-right: 20px;
            // margin-bottom: 20px;
          }
          .active {
            color: #ffffff;
            background-color: #0e6cb6;
          }
        }
      }
    }
  }
  .horizontal-box {
    flex-direction: column;
    .horizontal-tabs {
      display: block;
      /deep/.el-tabs__header {
        margin-bottom: 20px;
        .el-tabs__nav {
          width: 100%;
          .el-tabs__item {
            width: 33%;
            text-align: center;
            padding: 0;
            color: #666666;
            &:hover {
              color: #0e6cb6;
            }
          }
          .el-tabs__item.is-active {
            color: #0e6cb6;
          }
          .el-tabs__active-bar {
            width: 20% !important;
            left: 6%;
            background-color: #0e6cb6;
          }
        }
      }
    }
    .el-menu-vertical {
      display: none;
    }
    .all-modules {
      padding-left: 0;
    }
  }
}

.recruitment {
  ul {
    li {
      width: 200px;
      padding: 16px;
      font-size: 20px;
      margin-right: 10px;
      margin-bottom: 10px;
    }
  }
  .info1 {
    .f1-p {
      color: #ff6000;
      font-size: 28px;
    }
    .f1-sp {
      color: #ff6000;
      // background-color:rgb(128,141,142,.3);
      background-color: #fff2e3;
      margin-right: 10px;
      border-radius: 10%;
      padding: 1px;
    }
  }
  .info1,
  .info3 {
    p {
      font-size: 18px;
      line-height: 25px;
      i {
        margin-right: 10px;
      }
    }
  }

  .info,
  .info1,
  .info3 {
    padding: 12px;

    h3 {
      line-height: 35px;
      font-size: 25px;
      font-weight: bold;
      letter-spacing: 3px;
      margin-top: 12px;
    }

    div {
      line-height: 45px;
      font-size: 18px;
      letter-spacing: 3px;
    }
  }
}

@media screen and (min-width: 1200px) {
  .job {
    // width: 25%;
    padding: 2.25rem 1.25rem;
    margin-bottom: 20px;
    background-color: #eee;
    border-radius: 10px;
    .job:nth-child(3n) {
      margin-right: 0;
    }
    &:hover {
      background-color: rgba(8, 117, 203, 0.07);
    }
    .mon {
      font-size: 20px;
      margin-top: 12px;
      margin-bottom: 20px;
    }
    .el-divider {
      background-color: #444444;
    }
    .active {
      background-color: rgba(8, 117, 203, 0.07);
    }
    .jobname {
      font-weight: bold;
      font-size: 22px;
      color: #333;
    }
    .word {
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      line-clamp: 4;
      -webkit-box-orient: vertical;
      p {
        line-height:25px;
        font-size: 18px;
      }
    }
  }

  .el-menu-vertical {
    .el-menu-item {
      font-size: 24px;
      line-height: 33px;
      margin-bottom: 52px;
      .side {
        height: 33px;
        width: 6px;
        margin-right: 20px;
      }
    }
  }
  .core {
    .sec {
      width: 32%;
      margin-bottom: 12px;
    }
    .title {
      font-size: 22px;
      // min-height: 100px;
      color: #333;
      line-height: 52px;
      letter-spacing: 3px;
    }
    .hint {
      font-size: 16px;
    }
  }
  .recruitment {
    padding: 10px 100px;
    // display: flex;
    // flex-direction: row;
    // flex-wrap: wrap;
    // justify-content: space-between;
          display:grid;
    grid-template-columns: repeat(3,33.33%);
    gap: 10px 20px;
    ul {
      li {
        width: 200px;
        padding: 16px;
        font-size: 20px;
        margin-right: 10px;
        margin-bottom: 10px;
      }
    }
    .info1,
    .info3 {
      .f1-p {
        font-size: 28px;
      }
      p {
        font-size: 18px;
        line-height: 45px;
        i {
          margin-right: 10px;
        }
      }
    }

    .info,
    .info1,
    .info3 {
      padding: 12px;
      h3 {
        margin-bottom: 12px;
        font-size: 25px;
        font-weight: bold;
      }
      h2 {
        line-height: 40px;
        font-size: 25px;
        font-weight: bold;
        letter-spacing: 3px;
        margin-top: 12px;
        margin-bottom: 12px;
      }
      h6 {
        font-size: 1.5rem;
        line-height: 4rem;
      }
      div {
        line-height: 45px;
        font-size: 18px;
        letter-spacing: 3px;
      }
    }
  }
  .contactus {
    .cont-left {
      width: 100%;
      #allmap {
        height: 546px;
      }
    }
    .cont-right {
      width: 28%;
      p {
        line-height: 32px;
        font-size: 20px;
        letter-spacing: 2px;
      }
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 1200px) {
  //ipad pro
  .job {
    // width: 40%;
    padding: 2.25rem 1.25rem;
    margin-bottom: 20px;
    background-color: #eee;
    border-radius: 10px;
    .job:nth-child(3n) {
      margin-right: 0;
    }
    &:hover {
      background-color: rgba(8, 117, 203, 0.07);
    }
    .mon {
      margin-top: 12px;
      margin-bottom: 20px;
      font-size: 20px;
    }
    p {
      font-size:36px;
      line-height: 4.75rem;
    }
    .el-divider {
      background-color: #444444;
    }
    .active {
      background-color: rgba(8, 117, 203, 0.07);
    }
    .jobname {
      font-weight: bold;
      font-size: 2.5625rem;
      color: #333;
    }
    .word {
      font-size: 22px;
      line-height: 100px;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      line-clamp: 4;
      -webkit-box-orient: vertical;
     
    }
  }

  .el-menu-vertical {
    .el-menu-item {
      font-size: 20px;
      line-height: 30px;
      margin-bottom: 46px;
      .side {
        height: 30px;
        width: 6px;
        margin-right: 20px;
      }
    }
  }
  .core {
    .sec {
      width: 32%;
      margin-bottom: 12px;
    }
    .title {
      font-size: 18px;
      // min-height: 90px;
      color: #333;
      line-height: 32px;
      letter-spacing: 2px;
    }
    .hint {
      font-size: 16px;
    }
  }
  .recruitment {
    ul {
      li {
        width: 190px;
        padding: 16px;
        font-size: 16px;
        margin-right: 10px;
        margin-bottom: 10px;
      }
    }
    .info1,
    .info3 {
      .f1-p {
        font-size: 28px;
      }
      p {
        font-size: 18px;
        line-height: 34px;
        i {
          margin-right: 10px;
        }
      }
    }
    .info，.info1,
    .info3 {
      padding: 12px;
      h3 {
        font-size: 35px;
        font-weight: bold;
      }
      h2 {
        line-height: 40px;
        font-size: 33px;
        font-weight: bold;
        letter-spacing: 2px;
        margin-top: 12px;
        margin-bottom: 12px;
      }
      h6 {
        line-height: 1.5rem;
        font-size: 4rem;
      }
      div,
      p {
        line-height: 45px;
        font-size: 16px;
        letter-spacing: 2px;
      }
    }
  }
  .contactus {
    .cont-left {
      width: 62%;
      #allmap {
        height: 420px;
      }
    }
    .cont-right {
      width: 32%;
      p {
        line-height: 26px;
        font-size: 16px;
        letter-spacing: 2px;
      }
    }
  }
}
@media screen and (min-width: 414px) and (max-width: 768px) {
  //ipad
  .job {
    // width: 40%;
    padding: 2.25rem 1.25rem;
    margin-bottom: 20px;
    background-color: #eee;
    border-radius: 10px;
    // .job:nth-child(3n) {
    //   margin-right: 0;
    // }
    &:hover {
      background-color: rgba(8, 117, 203, 0.07);
    }
    .mon {
      font-size: 32px;
      margin-top: 12px;
      margin-bottom: 20px;
    }
    p {
      // margin: 10px 10px;
      line-height: 3.75rem;
    }
    .el-divider {
      background-color: #444444;
    }
    .active {
      background-color: rgba(8, 117, 203, 0.07);
    }
    .jobname {
      font-weight: bold;
      font-size: 42px;
      color: #333333;
    }
    .word {
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      font-size: 35px;
      line-height: 30px;
      -webkit-line-clamp: 4;
      line-clamp: 4;
      -webkit-box-orient: vertical;
    }
  }
  /deep/ .el-tabs__nav {
    line-height: 40px !important;
    .el-tabs__item {
      font-size: 18px;
    }
  }
  .el-menu-vertical {
    .el-menu-item {
      font-size: 18px;
      line-height: 30px;
      margin-bottom: 46px;
      .side {
        height: 30px;
        width: 6px;
        margin-right: 16px;
      }
    }
  }
  .core {
    .sec {
      width: 48%;
      margin-bottom: 6px;
    }
    .title {
      font-size: 16px;
      // min-height: 56px;
      color: #333;
      line-height: 26px;
      letter-spacing: 2px;
    }
    .hint {
      font-size: 14px;
    }
  }
  .recruitment {
    padding: 0;
    ul {
      li {
        // width: 190px;
        padding: 8px;
        font-size: 14px;
        margin-right: 6px;
        margin-bottom: 10px;
      }
    }
    .info1,
    .info3 {
      .f1-p {
        font-size: 25px;
      }
      p {
        font-size: 18px;
        line-height: 35px;
        i {
          margin-right: 10px;
        }
      }
    }
    .info,
    .info1,
    .info3 {
      padding: 12px;
      h3 {
        font-size: 30px;
        font-weight: bold;
      }
      h2 {
        line-height: 40px;
        font-size: 30px;
        font-weight: bold;
        letter-spacing: 2px;
        margin-top: 12px;
        margin-bottom: 12px;
      }
      h6 {
        line-height: 50px;
        font-size: 18px;
      }
      div,
      p {
        line-height: 35px;
        font-size: 14px;
        letter-spacing: 2px;
      }
    }
  }
  .contactus {
    .cont-left {
      width: 100%;
      #allmap {
        height: 300px;
        margin-bottom: 15px;
      }
    }
    .cont-right {
      width: 100%;
      p {
        line-height: 26px;
        font-size: 16px;
        letter-spacing: 2px;
      }
    }
  }
}
@media screen and (max-width: 414px) {
  //phone
 .job {
    // width: 40%;
    padding: 2.25rem 1.25rem;
    margin-bottom: 20px;
    background-color: #eee;
    border-radius: 10px;
    
    &:hover {
      background-color: rgba(8, 117, 203, 0.07);
    }
    .mon {
      font-size: 15px;
      margin-top: 12px;
      margin-bottom: 12px;
    }
    p {
      // margin: 10px 10px;
      line-height: 25px;
    }
    .el-divider {
      background-color: #444444;
    }
    .active {
      background-color: rgba(8, 117, 203, 0.07);
    }
    .jobname {
      // font-weight: bold;
      font-size: 18px;
      color: #333333;
    }
    .word {
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      font-size: 14px;
      line-height: 25px;
      -webkit-line-clamp: 4;
      line-clamp: 4;
      -webkit-box-orient: vertical;
    }
  }

  /deep/ .el-tabs__nav {
    line-height: 30px !important;
    .el-tabs__item {
      font-size: 16px;
    }
  }
  .el-menu-vertical {
    width: 22%;
    .el-menu-item {
      font-size: 14px;
      line-height: 18px;
      margin-bottom: 30px;
      .side {
        height: 18px;
        width: 4px;
        margin-right: 8px;
      }
    }
  }
  .all-modules {
    width: 100%;
  }
  .core {
    .sec {
      width: 48%;
      margin-bottom: 6px;
    }
    .title {
      font-size: 12px;
      // min-height: 40px;
      color: #333;
      line-height: 18px;
      letter-spacing: 2px;
    }
    .hint {
      font-size: 12px;
    }
  }
  .recruitment {
    ul {
      li {
        // width: 190px;
        width: 8.5rem;
        padding: 6px;
        font-size: 12px;
        margin-right: 6px;
        margin-bottom: 10px;
      }
    }
    .info1,
    .info3 {
      .f1-p {
        font-size: 15px;
      }
      p {
        i {
          margin-right: 10px;
        }
      }
    }

    .info,
    .info1,
    .info3 {
      padding: 12px;
      h3 {
        font-size: 17px;
        font-weight: bold;
      }
      h2 {
        line-height: 10px;
        font-size: 17px;
        letter-spacing: 1px;
        margin-top: 8px;
        margin-bottom: 10px;
        font-weight: bold;
      }
      h6 {
        font-size: 15px;
        line-height: 44px !important;
      }
      div,
      p {
        line-height: 2.25rem;
        font-size: 12px;
        letter-spacing: 1spx;
      }
    }
  }
  .contactus {
    .cont-left {
      width: 100%;
      #allmap {
        height: 200px;
        margin-bottom: 15px;
      }
    }
    .cont-right {
      width: 100%;
      p {
        line-height: 22px;
        font-size: 14px;
        letter-spacing: 1px;
      }
    }
  }
}
</style>